<mat-checkbox
  [(ngModel)]="value"
  (ngModelChange)="valueChanged($event)"
  [ngClass]="inputClass"
  [disabled]="disabled"
  [ngClass]="inputClass"
  [id]="inputId">
  <ng-content></ng-content>
</mat-checkbox>
